// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1BKr3","col":"styles_col__2clDv","fulfillmentStatus":"styles_fulfillmentStatus__1_icO","emailCol":"styles_emailCol__fE21E"};